import React, { ReactNode } from 'react'
import Typography, { TypographyProps } from '@material-ui/core/Typography'

interface IH1Prop {
  children: string | ReactNode
}
export const H1 = ({ children, ...props }: TypographyProps & IH1Prop) => (
  <Typography variant="h1" {...props}>
    {children}
  </Typography>
)
